<script>
  // This property is used by Modal.svelte to pass down the close function
  export let onClose;
</script>

<button
  on:click={onClose}
  type="button"
  class="bg-transparent bttn bttn-sm position-absolute p-0 right-0 z-index-100">
  <svg
    class="p-2"
    width="14"
    height="14"
    aria-hidden="true"
    focusable="false"
    fill-rule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    fill=""
    ><path
      d="M35.031 35.484c-.7.7-1.52 1.05-2.462 1.05-.941 0-1.762-.35-2.461-1.05L18 23.377 5.892 35.484c-.7.7-1.506 1.05-2.421 1.05-.915 0-1.722-.35-2.422-1.05C.35 34.784 0 33.977 0 33.063c0-.915.35-1.722 1.05-2.422l12.107-12.107L1.049 6.345C.35 5.645 0 4.84 0 3.924c0-.915.35-1.722 1.05-2.422.699-.7 1.506-1.05 2.42-1.05.916 0 1.723.35 2.422 1.05L18 13.61 30.188 1.502c.7-.7 1.507-1.05 2.422-1.05.915 0 1.722.35 2.421 1.05.7.7 1.05 1.507 1.05 2.422 0 .915-.35 1.722-1.05 2.421L22.843 18.534 35.031 30.64c.7.7 1.05 1.507 1.05 2.422 0 .914-.35 1.722-1.05 2.421z"
      fill="#a4a4a4" /></svg>
  <span class="sr-only">Close dialog</span>
</button>
